import { render, staticRenderFns } from "./bank-card.vue?vue&type=template&id=553df07d&scoped=true&"
import script from "./bank-card.vue?vue&type=script&lang=js&"
export * from "./bank-card.vue?vue&type=script&lang=js&"
import style0 from "./bank-card.vue?vue&type=style&index=0&id=553df07d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553df07d",
  null
  
)

export default component.exports